import React from 'react';

import { Select } from '@atoms';
import { DEFAULT_LOCALE, DEFAULT_LANGUAGE } from '@constants';

const PageLocaleSelect = ({
  title = 'Language:',
  selectValue = DEFAULT_LOCALE,
  disabled,
  onSelect,
  withInline = false,
  lineStyles,
  selectStyles,
  titleStyles,
  locales = DEFAULT_LANGUAGE,
  wrapperStyles,
  loading,
}) => {
  const [locale, setLocale] = React.useState(selectValue);

  React.useEffect(() => {
    setLocale(selectValue);
  }, [locales, selectValue]);

  const handleChange = (_locale) => {
    setLocale(_locale);
    onSelect(_locale);
  };

  const wrapperInlineStyles = withInline
    ? {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        ...lineStyles,
      }
    : null;

  return (
    <>
      <div style={{ ...wrapperInlineStyles, ...wrapperStyles }}>
        <div style={{ ...titleStyles }}>{title}</div>
        <Select
          aria-labelledby="language"
          onChange={handleChange}
          value={locale}
          style={withInline ? { ...selectStyles } : { marginBottom: 30, width: '60%', ...selectStyles }}
          disabled={disabled}
          loading={loading}
        >
          {locales.map((_locale) => (
            <Select.Option key={_locale.code} value={_locale.code}>
              {_locale.name}
            </Select.Option>
          ))}
        </Select>
      </div>
    </>
  );
};

export default PageLocaleSelect;
